import { HardHat } from 'lucide-react';

const EmConstrucao = () => {
    return (
        <div className="flex flex-col items-center justify-center h-full bg-gray-100 rounded-lg shadow-lg p-8 text-center">
            <HardHat size={64} className="text-yellow-500 mb-4" />
            <h1 className="text-4xl font-bold text-gray-800">EM CONSTRUÇÃO</h1>
            <p className="text-gray-600 mt-2">Esta página estará disponível em breve!</p>
        </div>
    );
};

export default EmConstrucao;